import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurPopup from '../../../common/aur-popup/AurPopup';

const Popup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);

  const onOkClickHandler = () => {
    setIsOpen(false);
    alert('Ok clicked');
  };

  const onCancelClickHandler = () => {
    setIsOpen(false);
    alert('Cancel clicked');
  };

  const onCloseClickHandler = () => {
    setIsOpen(false);
    alert('Cancel clicked');
  };

  const showDialog = () => {
    setIsOpen(true);
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Popup</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <div onClick={showDialog}>Open Dialog</div>
          <AurPopup
            open={isOpen}
            showCloseIcon={true}
            onOk={onOkClickHandler}
            onCancel={onCancelClickHandler}
            showBackIcon={true}
            labelActionOk={'Ok'}
            labelActionCancel={'Cancel'}
            onClose={onCloseClickHandler}
            popupHeading={'Popup Modal'}
          />
        </div>
      </div>
    </>
  );
};

export default Popup;
